<template lang="pug">
.fpui-preview-lightbox-image
  .lightbox-image(:style="style")
    img(:src="src")
  fp-loader(v-if="loading")
</template>

<script>
export default {
  props: {
    src: {type: String, required: true}
  },
  data () {
    return {
      loading: true,
      style: {},
      resizeEvent: null
    }
  },
  mounted () {
    const image = new window.Image()
    image.onload = () => {
      this.loading = false
      this.resizeImage(image)
    }
    this.resizeEvent = () => this.resizeImage(image)
    window.addEventListener('resize', this.resizeEvent)
    image.src = this.src
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeEvent)
  },
  methods: {
    resizeImage (image) {
      let { width } = image
      let { height } = image
      const windowHeight = window.innerHeight - 150
      const windowWidth = window.innerWidth - 150
      if ((width > windowWidth) || (height > windowHeight)) {
        const ratio = width / height
        const windowRatio = windowWidth / windowHeight
        if (ratio > windowRatio) {
          width = windowWidth
          height = width / ratio
        } else {
          height = windowHeight
          width = height * ratio
        }
      }
      this.style = {
        width: width + 'px',
        height: height + 'px',
        top: ((window.innerHeight - height) / 2) + 'px',
        left: ((window.innerWidth - width) / 2) + 'px'
      }
    }
  }
}
</script>

<style lang="less">
  .fpui-preview-lightbox-image {
    position: relative;
    height: 100%;
    z-index: -1;
    .lightbox-image {
      position: absolute;
      object-fit: cover;
      img {
        width: 100%;
      }
    }
  }
</style>
